import React, { useEffect, useState } from "react";
import instance from "../../ApiInstance/Inetrceptor";
import "./message.css";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  MenuItem,
  Skeleton,
  Menu,
  Tooltip,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
import StyledTableCell from "../../Tabletheme/Customtableheader";
import BackDropLoaderApi from "../../Allloader/BackDropLoaderApi";
import MappingStreamDrawer from "./MappingStreamDrawer";
import Swal from "sweetalert2";

const MappingStream = () => {
  const [showmoreLoader, setShowmoreLoader] = useState(false);
  const [backDrop, setBackDrop] = useState(false);
  const [loader, setLoader] = useState(true);
  const [drawerCaller, setDrawerCaller] = useState({
    name: "",
    data: "",
  });
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [sortObj, setSortObj] = useState({
    name: "mapping_stream_name",
    order: "asc",
  });
  const [pageNo, setPageNo] = useState(1);
  const [totalRecods, setTotalRecods] = useState(0);
  const [endPointTableData, setEndpointTableData] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const handleButtonClick = () => {
    setIsDrawerOpen(true);
  };
  const handleClick = (event, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowIndex(index);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setSelectedRowIndex(null);
  };
  const getMappingStream = (pageNumber = pageNo, searchinfo = searchValue) => {
    const body = {
      id: "",
      searchtext: searchinfo,
      pageno: pageNumber,
      pagesize: 10,
    };
    instance
      .post("api/v1/Master/MappingStream/Get", body)
      .then((res) => {
        if (res?.data?.Success) {
          setTotalRecods(res?.data?.Records ?? 0);
          if (pageNumber == 1) {
            setEndpointTableData(() => {
              return [...(res?.data?.Value ?? [])];
            });
          } else {
            setEndpointTableData((prev) => {
              return [...prev, ...(res?.data?.Value ?? [])];
            });
          }
        } else {
          setTotalRecods(0);
          setEndpointTableData((prevData) => {
            return [...prevData];
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };
  const deleteRow = (id) => {
    setBackDrop(true);
    try {
      instance
        .delete(`api/v1/Master/MappingStream/Delete/${id}`)
        .then((res) => {
          if (res?.data?.Success) {
            setEndpointTableData((prevData) => {
              return prevData.filter(row => row.mapping_stream_id !== id);
            });
             getMappingStream();
            setBackDrop(false);
            Swal.fire({
              icon: "success",
              title: "Deleted!",
              text: res?.data?.ResultMessage,
              customClass: {
                confirmButton: "custom-confirm-button-class",
              },
              buttonsStyling: false,
              showCancelButton: false,
              confirmButtonText: "OK",
              allowOutsideClick: false,
            });
          } else {
            setBackDrop(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: res?.data?.ResultMessage,
              customClass: {
                confirmButton: "custom-cancle-button-class",
              },
              buttonsStyling: false,
              showCancelButton: false,
              confirmButtonText: "OK",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          setBackDrop(false);
        })
        .finally(() => {
          setBackDrop(false);
        });
    } catch (err) {
      console.log(err);
      setBackDrop(false);
    }
  };
  useEffect(() => {
    getMappingStream();
  }, [sortObj]);
  return (
    <>
      <div className="parentMessage_div">
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="mb-4"
        >
          <p className="headingMessage_font">Mapping Streams</p>
          <p className="Messagehead_div"></p>
        </div>
        {backDrop && <BackDropLoaderApi open={backDrop} />}
        {isDrawerOpen && (
          <MappingStreamDrawer
            getMappingStream={getMappingStream}
            setIsDrawerOpen={setIsDrawerOpen}
            isDrawerOpen={isDrawerOpen}
            drawerCaller={drawerCaller}
            setBackDrop={setBackDrop}
          />
        )}
        <Grid container justifyContent="space-between" spacing={2}>
          <Grid item xl={2} lg={2.8} md={6} sm={12} xs={12}>
            <Button
              variant="contained"
              className="button_headermessage"
              onClick={() => {
                handleButtonClick();
                setDrawerCaller({
                  name: "Add",
                  data: "",
                });
              }}
              color="secondary"
              sx={{
                width: "100%",
              }}
            >
              Add Mapping Stream <AddIcon />
            </Button>
          </Grid>
          <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
            <div className="search-sectionmessage d-flex">
              <div>
                <img src="assets/Images/searchicon.svg" alt="Search Icon" />
              </div>
              <div className="search-inputmessage">
                <input
                  onKeyUp={(event) => {
                    if (event.key === "Enter") {
                      getMappingStream(1, event.target.value);
                    }
                  }}
                  onChange={(event) => {
                    setSearchValue(event.target.value);
                    if (event.target.value.length === 0) {
                      getMappingStream(1, "");
                    }
                  }}
                  type="text"
                  placeholder="Search / Filter"
                />
              </div>
            </div>
          </Grid>
        </Grid>

        <TableContainer sx={{ marginTop: 5, maxHeight: 600 }} component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow className="Table_row">
                <StyledTableCell>
                  Status Name
                  {sortObj?.order == "asc" ? (
                    <img
                      onClick={() => {
                        setSortObj((prev) => {
                          return {
                            ...prev,
                            order: "desc",
                          };
                        });
                      }}
                      src="assets/Images/Ascending.svg"
                      alt="Ascending"
                      style={{ width: "13px", marginLeft: "5px" }}
                    />
                  ) : (
                    <img
                      onClick={() => {
                        setSortObj((prev) => {
                          return {
                            ...prev,
                            order: "asc",
                          };
                        });
                      }}
                      src="assets/Images/descending.svg"
                      alt="Descending"
                      style={{ width: "13px", marginLeft: "5px" }}
                    />
                  )}
                </StyledTableCell>
                <StyledTableCell>Status URL</StyledTableCell>
                <StyledTableCell>Description</StyledTableCell>
                <StyledTableCell />
              </TableRow>
            </TableHead>
            {loader ? (
              <>
                {new Array(5).fill(3).map((element, index) => {
                  return (
                    <TableRow key={index}>
                      {new Array(4).fill(1).map((element, index) => {
                        return (
                          <TableCell align="center" key={index}>
                            <Skeleton
                              variant="rounded"
                              width={"100%"}
                              height={60}
                            />
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </>
            ) : (
              <>
                {endPointTableData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      <p>No Data Found</p>
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableBody>
                    {endPointTableData.map((singleRowInformation, index) => (
                      <TableRow key={index}>
                         {/* key={singleRowInformation?.mapping_stream_id}> */}
                        <TableCell style={{ minWidth: "15rem", maxWidth: "15rem"}}>
                          {singleRowInformation?.mapping_stream_name}
                        </TableCell>
                        <TableCell style={{ minWidth: "15rem", maxWidth: "15rem", overflow: "hidden",
                          textOverflow: "ellipsis"}}>
                              <Tooltip
                            title={singleRowInformation?.mapping_stream_url}
                            arrow
                            placement="top"
                          >
                             {singleRowInformation?.mapping_stream_url?.length > 30
                                ? singleRowInformation?.mapping_stream_url.substring(0, 30) +
                                  "..."
                                : singleRowInformation?.mapping_stream_url}
                              </Tooltip>
                        </TableCell>
                        <TableCell style={{ minWidth: "25rem", maxWidth: "25rem", overflow: "hidden",
                          textOverflow: "ellipsis"}}>
                              <Tooltip
                            title={singleRowInformation?.mapping_stream_desc}
                            arrow
                            placement="top"
                          >
                             {singleRowInformation?.mapping_stream_desc?.length > 100
                                ? singleRowInformation?.mapping_stream_desc.substring(0, 100) +
                                  "..."
                                : singleRowInformation?.mapping_stream_desc}
                              </Tooltip>
                        </TableCell>
                        <TableCell style={{ minWidth: "5rem", maxWidth: "5rem"}}>
                          <div style={{ textAlign: "center" }}>
                            <Button
                              id="basic-button"
                              aria-controls={
                                Boolean(anchorEl)
                                  ? `basic-menu-${index}`
                                  : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={
                                Boolean(anchorEl) ? "true" : undefined
                              }
                              onClick={(event) => {
                                handleClick(event, index);
                              }}
                            >
                              <MoreVertIcon />
                            </Button>
                            <Menu
                              id={`basic-menu-${index}`}
                              anchorEl={anchorEl}
                              open={
                                selectedRowIndex !== null &&
                                selectedRowIndex === index
                              }
                              onClose={handleClose}
                              MenuListProps={{
                                "aria-labelledby": `basic-button-${index}`, 
                              }}
                            >
                              <MenuItem
                                onClick={() => {
                                  handleClose();
                                  handleButtonClick();
                                  setDrawerCaller({
                                    name: "edit",
                                    data: singleRowInformation,
                                  });
                                }}
                              >
                                Edit
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  handleClose();

                                  Swal.fire({
                                    icon: "question",
                                    text: "Are you sure you want to delete",
                            
                                    customClass: {
                                      confirmButton:
                                        "custom-confirm-button-class",
                                      cancelButton:
                                        "custom-cancle-button-class",
                                    },
                                    buttonsStyling: false,
                                    showCancelButton: true,
                                    confirmButtonText: "OK",
                                    cancelButtonText: "Cancel",
                                    allowOutsideClick: false,
                                    reverseButtons: true,
                                  }).then((responce) => {
                                    if (responce?.isConfirmed) {
                                      deleteRow(
                                        singleRowInformation?.mapping_stream_id
                                      );
                                    } else {
                                    }
                                  });
                                }}
                              >
                                Delete
                              </MenuItem>
                            </Menu>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
        <Grid item xs={12} className="mt-4" sx={{ textAlign: "center" }}>
          {totalRecods > endPointTableData.length && 
            endPointTableData.length > 0 && (
              <Button
                id="back-button"
                variant="contained"
                color="secondary"
                sx={{ textTransform: "none" }}
                onClick={() => {
                  setShowmoreLoader(true);
                  setPageNo((prev) => prev + 1);
                  getMappingStream(pageNo + 1,searchValue,sortObj);
                }}
              >
                {showmoreLoader ? "loading" : "Show More"}
              </Button>
            )}
        </Grid>
      </div>
    </>
  );
};

export default MappingStream;
